import { Injectable, signal  } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChatStateService {
  chatResetState = new Subject<any>;

  // Chat Gpt default config which are global set 
  chatConfigDefaultState = new BehaviorSubject<any>('');

  // change in  Chat Gpt config 
  chatConfigState = new BehaviorSubject<any>("");

  // PromptInput add to input feild
  promptInputState = new Subject<any>;

  // PromptInput submit to feature
  chatPromptState = new BehaviorSubject<any>("");


  // to mark feature active with filetypes
  activeFeaturState = new BehaviorSubject<any>('');
  //  to hold the feature file 
  activeFeatureUplaodFile = new BehaviorSubject<any>('');
  byodFileUpload = new BehaviorSubject<any>('');
  translateFileUpload = new BehaviorSubject<any>('');
  transcribeFileUpload = new BehaviorSubject<any>('');
  chatModelState=new BehaviorSubject<any>('azure');

  // To check current active feature working on 
  featureState = new BehaviorSubject<any>('');
  updateChatConfig = new BehaviorSubject<any>('');

 
  chatModeState = new BehaviorSubject<any>('');

  // chathistroyUpdate
  chatHistroyUpdate = new Subject<any>; 
  chatHistoryDetailState = new BehaviorSubject<any>(null);



  chatDataAppendState = new BehaviorSubject<any>(''); 

  stopStreamSignal = signal(false);

  promptFiredSignal = signal(false);

  uploadFileSignal = signal(false);

  //datalabs 
  datalabsFile = new BehaviorSubject<any>('');
  datalabsStopProgress = new Subject();
  // datalabsChat = new BehaviorSubject<any>('');

  imagePromptStatus = new BehaviorSubject<any>(null)
  

  constructor() { }

  stopStreaming() {
    console.log("Stop straming requested");
    this.stopStreamSignal.set(false);
  }

  startStreaming() {
    this.stopStreamSignal.set(true);
  }

  inputPromptFired(status:boolean) {
   this.promptFiredSignal.set(status);
  }

  fileuploadSignal(status:boolean) {
    this.uploadFileSignal.set(status);
  }
}
